/**
 * List of Behavior name introduced in Cronos BehaviorExperiments.cs
 * Please sort alphabetically with experiment id comment for visibility
 */
export enum FeatureName {
    ActivitiesRecentReviews = 'ActivitiesRecentReviews', // ACT-4093
    ActivitiesRecentSearch = 'ActivitiesRecentSearch', // ACT-4032
    ActivitiesTest = 'ActivitiesTest', // This feature is for testing purpose
    BadgesV2ActivityCard = 'BadgesV2ActivityCard', // ACT-4100
    BadgesV2DetailsPage = 'BadgesV2DetailsPage', // ACT-4285
    DetailPageRevamp = 'DetailPageRevamp', // ACT-4175
    LowHighResetPriceFilter = 'LowHighResetPriceFilter', // ACT-3489
    OfferGroupCardExpansion = 'OfferGroupCardExpansion',
    SearchBoxFeatureGroup = 'SearchBoxFeatureGroup', // InCitySearch, RecentSearch, NewOverlay, EmptyStateSuggestions
    SearchBoxNearMeFeature = 'SearchBoxNearMeFeature', // ACT-3881
    ShowAboutActivityPanel = 'ShowAboutActivityPanel', // ACTB-SEO-CONTENT
    ExpandFirstOfferOnDetailsLanding = 'ExpandFirstOfferOnDetailsLanding', // ACT-4277
    PageContainerSpacing = 'PageContainerSpacing', // ACT-4352
    RecommendedActivitiesOnDetailPage = 'RecommendedActivitiesOnDetailPage', // ACT-4608
    RedirectGenericErrorComponent = 'RedirectGenericErrorComponent', // ACT-4585
    ImproveUnavailableOffer = 'ImproveUnavailableOffer', // ACT-4559
    SubcategoryFilter = 'SubcategoryFilter', // ACT-4606
    ActivitiesHighlights = 'ActivitiesHighlights', // ACT-4602
    ExpandSectionsForBots = 'ExpandSectionsForBots',
    GlobalKeywordSearch = 'GlobalKeywordSearch', // ACT-4582
    OfferComparison = 'OfferComparison', // ACT-4938
    ContinueYourBooking = 'ContinueYourBooking', // ACT-4940
    RemoveCityPageImage = 'RemoveCityPageImage', // ACT-5130
    MaintainSelectedOfferOnDetails = 'MaintainSelectedOfferOnDetails', // AFT-1181
    AppendTravelDateActivityUrl = 'AppendTravelDateActivityUrl',
    SortOfferOptionAscending = 'SortOfferOptionAscending', // ACT-5136
    EmptyStateSuggestionsRedirect = 'EmptyStateSuggestionsRedirect', // ACT-5137
    FilterWithoutUpdatingHistory = 'FilterWithoutUpdatingHistory', // ACT-5224
    UpdateAvailabilitySlotAlert = 'UpdateAvailabilitySlotAlert', // ACT-5287
    DetailPageForSimCard = 'DetailPageForSimCard', // ACT-5340
    NewFilters = 'NewFilters', // ACT-5236
    SearchByCategories = 'SearchByCategories', // ACT-5365
    HideSeeDetailsButtonForNoContent = 'HideSeeDetailsButtonForNoContent', // ACT-5408
    VIPBadgeSearch = 'VIPBadgeSearch', // ACTB-1820
    AutoApplyCategoryFilter = 'AutoApplyCategoryFilter', // ACT-5475
    SearchFlowRefactor = 'SearchFlowRefactor', // ACT-5425
    VIPBadgeDetail = 'VIPBadgeDetail', // ACTB-1823
    EnableActivitiesForCnOriginWeb = 'EnableActivitiesForCnOriginWeb', // CG-CN-ACTIVITIES-WEB
    EnableActivitiesForCnOriginAndroid = 'EnableActivitiesForCnOriginAndroid', // CG-CN-ACTIVITIES-AND
    EnableActivitiesForCnOriginIos = 'EnableActivitiesForCnOriginIos', // CG-CN-ACTIVITIES-IOS
    ActivitiesCityNamePlaceholderBehavior = 'ActivitiesCityNamePlaceholderBehavior', // ACT-5481
    AddRedemptionInstructionOnDetails = 'AddRedemptionInstructionOnDetails', // ACT-5093
    WordBreakOnDetailPage = 'WordBreakOnDetailPage', // ACTD-8
}
